export const common = {
  // Navigation
  nav: {
    home: 'Startseite',
    services: 'Dienstleistungen',
    aiSolutions: 'KI-Lösungen',
    bookDemo: 'Demo buchen'
  },
  
  // Hero Section
  hero: {
    title: 'KI-gestütztes Marketing Excellence',
    subtitle: 'Transformieren Sie Ihr Unternehmen mit modernsten Lösungen der künstlichen Intelligenz und Premium-Marketing-Strategien, die messbare Ergebnisse liefern',
    bookConsultation: 'Kostenlose Beratung buchen',
    exploreAI: 'KI-Lösungen erkunden',
    skipIntro: 'Intro überspringen'
  },
  
  // Services Section
  services: {
    title: 'Unsere Dienstleistungen',
    subtitle: 'Umfassende KI-gestützte Marketing-Lösungen, die darauf ausgelegt sind, Ihr Unternehmenswachstum zu beschleunigen und Ihre digitale Präsenz zu maximieren.',
    discussProject: 'Projekt besprechen',
    aiSeo: {
      title: 'KI-gestützte SEO',
      description: 'Fortschrittliche Suchmaschinenoptimierung mit Machine-Learning-Algorithmen zur Vorhersage und Anpassung an Suchmaschinenänderungen.',
      features: [
        'Prädiktive Keyword-Analyse',
        'Automatisierte Content-Optimierung',
        'Echtzeit-Ranking-Überwachung',
        'Konkurrenz-Intelligence'
      ]
    },
    ppcManagement: {
      title: 'Intelligentes PPC-Management',
      description: 'Automatisierte Pay-per-Click-Kampagnen, die sich in Echtzeit für maximale Conversion-Raten und ROI optimieren.',
      features: [
        'Intelligente Gebotsoptimierung',
        'Dynamische Anzeigenerstellung',
        'Zielgruppen-Targeting KI',
        'Leistungsprognose'
      ]
    },
    socialMedia: {
      title: 'Social Media Automatisierung',
      description: 'KI-gesteuerte Social-Media-Strategien, die Ihre Zielgruppe mit personalisierten Inhalten und optimalem Timing ansprechen.',
      features: [
        'Content-Generierungs-KI',
        'Engagement-Optimierung',
        'Influencer-Matching',
        'Sentiment-Analyse'
      ]
    },
    emailMarketing: {
      title: 'E-Mail-Marketing KI',
      description: 'Personalisierte E-Mail-Kampagnen mit Machine Learning zur Steigerung von Öffnungsraten und Conversions.',
      features: [
        'Verhaltens-Targeting',
        'Versandzeitoptimierung',
        'Betreffzeilen-Tests',
        'Abwanderungsvorhersage'
      ]
    },
    analytics: {
      title: 'Analytics & Insights',
      description: 'Tiefgreifende Datenanalyse und prädiktive Einblicke, die strategische Entscheidungen leiten und Markttrends vorhersagen.',
      features: [
        'Prädiktive Analytik',
        'Customer Journey Mapping',
        'ROI-Optimierung',
        'Markttrend-Analyse'
      ]
    },
    chatbot: {
      title: 'KI-Chatbot-Entwicklung',
      description: 'Intelligente Konversations-KI, die 24/7 Kundensupport und Lead-Qualifizierung bietet.',
      features: [
        'Natürliche Sprachverarbeitung',
        'Lead-Qualifizierung',
        'Multi-Plattform-Integration',
        'Lernalgorithmen'
      ]
    }
  },
  
  // AI Capabilities Section
  aiCapabilities: {
    title: 'Die Stärken von KI',
    subtitle: 'Entdecken Sie die modernsten Technologien der künstlichen Intelligenz, die unsere Marketing-Lösungen antreiben und außergewöhnliche Ergebnisse für unsere Kunden erzielen.',
    learnMore: 'Mehr erfahren',
    readyTitle: 'Bereit für KI-gestütztes Marketing?',
    readySubtitle: 'Buchen Sie eine personalisierte Demo, um zu sehen, wie unsere KI-Lösungen Ihre Marketing-Strategie transformieren und Ihr Unternehmenswachstum beschleunigen können.',
    bookDemo: 'Demo jetzt buchen',
    machineLearning: {
      title: 'Machine Learning Optimierung',
      description: 'Unsere Algorithmen lernen kontinuierlich aus Ihren Kampagnendaten, um die Leistung automatisch zu verbessern.',
      stats: ['95% Genauigkeitsverbesserung', '60% Kostenreduzierung', '24/7 Optimierung']
    },
    predictiveAnalytics: {
      title: 'Prädiktive Analytik',
      description: 'Prognostizieren Sie Markttrends und Kundenverhalten, um der Konkurrenz einen Schritt voraus zu sein.',
      stats: ['85% Vorhersagegenauigkeit', '3x schnellere Einblicke', 'Echtzeit-Prognosen']
    },
    nlp: {
      title: 'Natürliche Sprachverarbeitung',
      description: 'Fortschrittliche NLP-Fähigkeiten für Content-Erstellung, Sentiment-Analyse und Kundenkommunikation.',
      stats: ['99% Sprachgenauigkeit', '50+ unterstützte Sprachen', 'Echtzeit-Verarbeitung']
    }
  },
  
  // Value Proposition Section
  valueProposition: {
    title: 'Warum BlecInk wählen',
    subtitle: 'Wir kombinieren menschliche Kreativität mit künstlicher Intelligenz, um Marketing-Lösungen zu liefern, die nicht nur innovativ, sondern transformativ für Ihr Unternehmenswachstum sind.',
    readyTitle: 'Bereit, Ihr Marketing zu transformieren?',
    readySubtitle: 'Schließen Sie sich über 500+ Unternehmen an, die ihr Wachstum mit unseren KI-gestützten Marketing-Lösungen revolutioniert haben.',
    startTransformation: 'Transformation starten',
    aiFirst: {
      title: 'KI-First-Ansatz',
      description: 'Nutzen Sie Machine Learning und künstliche Intelligenz, um jeden Aspekt Ihrer Marketing-Kampagnen für maximalen ROI und Leistung zu optimieren.'
    },
    acceleratedGrowth: {
      title: 'Beschleunigtes Wachstum',
      description: 'Unsere bewährten Methoden und KI-gesteuerten Einblicke helfen Unternehmen, 300% schnelleres Wachstum im Vergleich zu traditionellen Marketing-Ansätzen zu erreichen.'
    },
    guaranteedResults: {
      title: 'Garantierte Ergebnisse',
      description: 'Wir stehen hinter unserer Arbeit mit Leistungsgarantien und transparenter Berichterstattung, die genau zeigt, wie Ihre Investition das Unternehmenswachstum vorantreibt.'
    }
  },
  
  // Contact Section
  contact: {
    title: 'Loslegen',
    subtitle: 'Bereit, Ihr Marketing mit KI zu transformieren? Kontaktieren Sie uns heute oder buchen Sie eine personalisierte Demo, um unsere Lösungen in Aktion zu sehen.',
    contactUs: 'Kontakt',
    bookDemo: 'Demo buchen',
    fullName: 'Vollständiger Name',
    emailAddress: 'E-Mail-Adresse',
    companyName: 'Firmenname',
    phoneNumber: 'Telefonnummer',
    message: 'Nachricht',
    preferredDate: 'Bevorzugtes Datum',
    preferredTime: 'Bevorzugte Uhrzeit',
    businessGoals: 'Geschäftsziele & Herausforderungen',
    sendMessage: 'Nachricht senden',
    sending: 'Wird gesendet...',
    booking: 'Wird gebucht...',
    successContact: 'Vielen Dank! Wir melden uns innerhalb von 24 Stunden bei Ihnen.',
    successDemo: 'Demo erfolgreich gebucht! Wir senden Ihnen in Kürze eine Bestätigungs-E-Mail.',
    error: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
    placeholders: {
      fullName: 'Geben Sie Ihren vollständigen Namen ein',
      email: 'Geben Sie Ihre E-Mail ein',
      company: 'Geben Sie Ihren Firmennamen ein',
      phone: 'Geben Sie Ihre Telefonnummer ein',
      message: 'Erzählen Sie uns von Ihrem Projekt und Ihren Zielen...',
      goals: 'Erzählen Sie uns von Ihren aktuellen Marketing-Herausforderungen und was Sie erreichen möchten...'
    },
    contactInfo: {
      email: 'E-Mail senden',
      phone: 'Anrufen',
      responseTime: 'Antwortzeit',
      responseValue: '&lt; 24 Stunden'
    }
  },
  
  // Footer
  footer: {
    description: 'Transformation von Unternehmen mit KI-gestützten Marketing-Lösungen, die messbare Ergebnisse liefern und das Wachstum in der digitalen Landschaft beschleunigen.',
    services: 'Dienstleistungen',
    company: 'Unternehmen',
    aboutUs: 'Über uns',
    aiTechnology: 'KI-Technologie',
    contact: 'Kontakt',
    caseStudies: 'Fallstudien',
    blog: 'Blog',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    poweredBy: 'Powered by Readdy',
    copyright: '© 2025 BlecInk. Alle Rechte vorbehalten.'
  }
};